<template>
    <v-container grid-list-xl>
        <cook :loading="loading" v-if="favorite.cooks" :cooks="favorite.cooks" />

        <v-layout v-if="showMoreCooks" column>
            <v-flex xs12>
                <v-layout justify-center row>
                    <v-btn color="secondary" @click="showMoreCooks">جلب المزيد</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        FAVORITE_COOKS
    } from '../../graphql/Cooks'
    import {
        mapGetters
    } from 'vuex'
    import Cook from '../Shared/Cook.vue'

    const pageSize = 2

    export default {
        name: 'Favorites',
        data() {
            return {
                pageNum: 1,
                showMoreEnabled: true,
                favorite: '',
                cooks: ''
            }
        },
        apollo: {
            favorite: {
                query: FAVORITE_COOKS,
                variables: {
                    pageNum: 1,
                    pageSize
                }
            }
        },
        components: {
            'cook': Cook
        },
        computed: {
            ...mapGetters(['loading'])
        },
        methods: {
            showMoreCooks() {
                this.pageNum += 1
                // fretch more data and transform original result
                this.$apollo.queries.favorite.fetchMore({
                    variables: {
                        // pageNum incremented by 1
                        pageNum: this.pageNum,
                        pageSize
                    },
                    updateQuery: (prevResult, {
                        fetchMoreResult
                    }) => {

                        const newCooks = fetchMoreResult.favorite.cooks
                        const hasMore = fetchMoreResult.favorite.hasMore
                        this.showMoreEnabled = hasMore

                        return {
                            favorite: {
                                __typename: prevResult.favorite.__typename,
                                // merge previous cooks with new cooks
                                cooks: [
                                    ...prevResult.favorite.cooks,
                                    ...newCooks
                                ],
                                hasMore
                            }
                        }
                    }
                })
            },
            goToCook(cookId) {
                this.$router.push(`/cooks/${cookId}`)
            }
        }
    }
</script>

<style scoped>
.cook-1 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    font-family: 'Almarai', sans-serif !important; /* this was it */
}
</style>